export default [
    'inlineExtension',
    'hardBreak',
    'mention',
    'emoji',
    'date',
    'status',
    'placeholder',
    'inlineCard',
    'formatted_text_inline',
    'code_inline',
];
//# sourceMappingURL=inline.js.map